import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import LoadingScreen from 'src/components/LoadingScreen';
import AuthGuard from 'src/components/Guards/AuthGuard';
import GuestGuard from 'src/components/Guards/GuestGuard';
import DVSOwnerGuard from 'src/components/Guards/DVSOwnerGuard'
import DVSValuatorGuard from 'src/components/Guards/DVSValuatorGuard'
import DVSOwnerAdminGuard from 'src/components/Guards/DVSOwnerAdminGuard'

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={props => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/errors/NotFoundView'))
  },
  {
    exact: true,
    path: '/accessdenied',
    component: lazy(() => import('src/views/errors/AccessDenied'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView/JWTLogin'))
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,

    path: '/reset_password',
    component: lazy(() => import('src/views/auth/LoginView/Reset_Password'))
  },
  {
    exact: true,

    path: '/verifyOTP',
    component: lazy(() => import('src/views/auth/LoginView/VerifyOTP'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/forgot',
    component: lazy(() => import('src/views/auth/LoginView/Forgot_Password'))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/confirm',
    component: lazy(() =>
      import('src/views/auth/LoginView/Confirm_forgot_password')
    )
  },


  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app/home',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/home/HomeView/List'))
      },
      
      {
        exact: true,
        path: '/app/admin/faculties',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Faculties/List'))
      },
      {
        exact: true,
        path: '/app/admin/faculties_billing',
        guard: DVSOwnerAdminGuard,
        component: lazy(() => import('src/views/FacultiesBilling/List'))
      },
      {
        exact: true,
        path: '/app/admin/packets',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Packets/List'))
      },
      {
        exact: true,
        path: '/app/admin/answer_sheets',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/AnswerSheets/List'))
      },
      {
        exact: true,
        path: '/app/admin/valuators',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Valuators/List'))
      },
      {
        exact: true,
        path: '/app/admin/faculty_courses',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/FacultyCourseMap/List'))
      },
      {
        exact: true,
        path: '/app/admin/moderators',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Moderators/List'))
      },
      {
        exact: true,
        path: '/app/admin/valuation_schedules',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/ValuationSchedules/List'))
      },
      {
        exact: true,
        path: '/app/admin/courses',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Courses/List'))
      },
      {
        exact: true,
        path: '/app/admin/courses/:id',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Courses/CourseDetailView/DetailView'))
      },
      {
        exact: true,
        path: '/app/admin/va-mo',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/VaMoMap/List'))
      },
      {
        exact: true,
        path: '/app/admin/reports',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Reports'))
      },
      {
        exact: true,
        path: '/app/admin/reports/daily_log',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Reports/CertificateRegister'))
      },
      {
        exact: true,
        path: '/app/admin/reports/daily_valuation',
        guard: DVSOwnerGuard,
        component: lazy(() => import('src/views/Reports/DailyValuation'))
      },

      {
        exact: true,
        path: '/app/valuator/home',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/HomeView'))
      },
      //valuation
      {
        exact: true,
        path: '/app/valuators/packets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Valuation/Packets/Packets'))
      },
      {
        exact: true,
        path: '/app/valuators/packets/:id/answer_sheets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Valuation/AnswerSheets/AnswerSheets'))
      },
      {
        exact: true,
        path: '/app/valuators/packets/answer_sheets/:id',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Valuation/AnswerSheetView/AnswerSheetView'))
      },

      //moderatiom
      {
        exact: true,
        path: '/app/moderators/packets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Moderation/Packets/Packets'))
      },
      {
        exact: true,
        path: '/app/moderators/packets/:id/answer_sheets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Moderation/AnswerSheets/AnswerSheets'))
      },
      {
        exact: true,
        path: '/app/moderators/packets/answer_sheets/:id',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/Moderation/AnswerSheetView/AnswerSheetView'))
      },


      //third valuation
      {
        exact: true,
        path: '/app/third_valuation/packets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/ThirdValuation/Packets/Packets'))
      },
      {
        exact: true,
        path: '/app/third_valuation/packets/:id/answer_sheets',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/ThirdValuation/AnswerSheets/AnswerSheets'))
      },
      {
        exact: true,
        path: '/app/third_valuation/packets/answer_sheets/:id',
        guard: DVSValuatorGuard,
        component: lazy(() => import('src/views/ThirdValuation/AnswerSheetView/AnswerSheetView'))
      },

        //re valuation
        {
          exact: true,
          path: '/app/reval_valuation/packets',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/Revaluation/Packets/Packets'))
        },
        {
          exact: true,
          path: '/app/reval_valuation/packets/:id/answer_sheets',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/Revaluation/AnswerSheets/AnswerSheets'))
        },
        {
          exact: true,
          path: '/app/reval_valuation/packets/answer_sheets/:id',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/Revaluation/AnswerSheetView/AnswerSheetView'))
        },


         //cross valuation
         {
          exact: true,
          path: '/app/cross_valuation/packets',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/CrossEvaluation/Packets/Packets'))
        },
        {
          exact: true,
          path: '/app/cross_valuation/packets/:id/answer_sheets',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/CrossEvaluation/AnswerSheets/AnswerSheets'))
        },
        {
          exact: true,
          path: '/app/cross_valuation/packets/answer_sheets/:id',
          guard: DVSValuatorGuard,
          component: lazy(() => import('src/views/CrossEvaluation/AnswerSheetView/AnswerSheetView'))
        },
    ]
  },


  {
    path: '*',
    // layout: MainLayout,
    routes: [
      {
        exact: true,
        guard: GuestGuard,
        path: '/',
        component: lazy(() => import('src/views/auth/LoginView/JWTLogin'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

export default routes;
